export default __webpack_public_path__ + "static/media/fullLogo.39c1d7a3.png";